import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** The one class-merge helper — clsx + tailwind-merge. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
